import { Component, OnInit } from '@angular/core';
import Speech from 'speak-tts';

@Component({
  selector: 'ngx-ezo-text-to-speech-service',
  template: `<p>Text To Speech Service</p> 
  <button nbButton (click)="start(html)"> start</button>
  <button nbButton (click)="pause()"> pause </button>
  <button nbButton (click)="resume()"> resume </button>
  <br>
  <input nbInput type="text" [(ngModel)]="html">
  <br>
  <select #langSelect *ngIf="speechData" (change)="setLanguage(langSelect.value)">
    <option [value]="i" *ngFor="let voice of speechData.voices;let i = index;">
      {{voice.name}} - {{voice.lang}}
    </option>
  </select>
  <br>` 
})
export class EzoTexttoSpeechServiceComponent implements OnInit {
  html = '';
  result = '';
  speech: any;
  text;
  speechData: any;
  constructor() { 
    this.speech = new Speech(); // will throw an exception if not browser supported
    if (this.speech.hasBrowserSupport()) {
      // returns a boolean
      console.log('speech synthesis supported');
      this.speech
        .init({
          volume: 1,
          lang: 'en-GB',
          rate: 1,
          pitch: 1,
          voice: 'Google UK English Male',
          splitSentences: true,
          listeners: {
            onvoiceschanged: (voices) => {
              console.log('Event voiceschanged', voices);
            },
          },
        })
        .then((data) => {
          // The "data" object contains the list of available voices and the voice synthesis params
          // console.log('Speech is ready, voices are available', data);
          this.speechData = data;
          data.voices.forEach((voice) => {
            // console.log(voice.name + " "+ voice.lang)
          });
        })
        .catch((e) => {
          console.error('An error occured while initializing : ', e);
        });
    }else
    console.error("browser not supporte");
  }

  ngOnInit(): void {
  }

  start(text) {
    this.speech
      .speak({
        text: text,
      })
      .then(() => {
        console.log('Success !');
      })
      .catch((e) => {
        console.error('An error occurred :', e);
      });
  }
  pause() {
    this.speech.pause();
  }
  resume() {
    this.speech.resume();
  }

  setLanguage(i) {
    console.log(i);
    console.log(
      this.speechData.voices[i].lang + this.speechData.voices[i].name
    );
    this.speech.setLanguage(this.speechData.voices[i].lang);
    this.speech.setVoice(this.speechData.voices[i].name);
  }
}


